// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__AWREh","head":"ProcedureTableInfo_head__3Svu3"};